import React, { ComponentPropsWithoutRef, forwardRef } from 'react';
import { identifyComponent } from '../../util';
import { Icon } from '../Icon';
import css from './index.module.scss';

export const ListItemIcon = forwardRef<SVGSVGElement, ComponentPropsWithoutRef<typeof Icon>>(
  ({ size = 16, ...props }, ref) => (
    <div
      data-component="ListItemIcon"
      className={css.listItemIcon}
      {...identifyComponent('list-item-icon')}
    >
      <Icon ref={ref} size={size} {...props} />
    </div>
  ),
);

ListItemIcon.displayName = 'ListItemIcon';
